import React from 'react';

export interface ExternalLinkProps extends React.HTMLProps<HTMLAnchorElement> {}

export const ExternalLink: React.FC<ExternalLinkProps> = (props) => {
  return (
    <a target={'_blank'} rel="noreferrer" className="underline" {...props} />
  );
};
